import { render, staticRenderFns } from "./StageAction.vue?vue&type=template&id=9f6d6320&scoped=true"
import script from "./StageAction.vue?vue&type=script&lang=js"
export * from "./StageAction.vue?vue&type=script&lang=js"
import style0 from "./StageAction.vue?vue&type=style&index=0&id=9f6d6320&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f6d6320",
  null
  
)

export default component.exports